import axios from 'axios'
import config from '@/config/index'
axios.defaults.baseURL = config.host

let Log = new robotLog();
Log.getId('beee49dbdf0fd147faa190a206db05e2');
window.Log = Log;

export let serviceHost=config.host;
axios.interceptors.response.use(function (response) {
    if (response.data.code != 200) {
        Log.warning({'data': response.data, 'open_token': getCookie('token'), 'open_user_phone': getCookie('userTel')})
    }
  if (response.data.code == 2720) {
    alert('登陆已过期，请重新登陆')
    removeCookie('token')
    removeCookie('userTel')
    window.location.href = '/login'
    return
  }
  return response;
}, function (error) {
    Log.error({'data': error, 'open_token': getCookie('token'), 'open_user_phone': getCookie('userTel')})
    return Promise.reject(error);
});
let getCookie = (name) => {
    if (document.location.host == 'opentw.ainirobot.com') {
        name = name + '_tw'
    }
  let arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)")
  if(arr=document.cookie.match(reg)) {
    return arr[2]
  } else {
    return null;
  }
}
let removeCookie = (name)=> {
    let flag = false
    if (document.location.host == 'opentw.ainirobot.com') {
        name = name + '_tw'
        flag = true
    }
  let exp = new Date();
  exp.setTime(exp.getTime() - 1);
    let cval = null;
    if (flag) {
        let str = name.slice(0, -3)
        cval = this.getCookie(str);
        
    } else {
        cval = this.getCookie(name);
    }
  if (cval != null) {
    if (document.location.host == 'open.ainirobot.com' || document.location.host == 'opentw.ainirobot.com') {
      document.cookie = name + "="+ cval + ";expires=" + exp.toGMTString() +";domain=.ainirobot.com"
    } else {
      document.cookie = name + "="+ cval + ";expires=" + exp.toGMTString()
    }
  }

}
export let setHeaders = () => {
  axios.defaults.headers = {
    authorization: getCookie('token'),
    // 'Content-Type': 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded'
  }
}
setHeaders()
// axios.defaults.headers.post['Content-Type'] = 'application/json';//配置请求头
//验证码
export let Register = (data) => {
  return axios.post('/user/code', data)
}
// 注册
export let register1 = (data) => {
  return axios.post('user/register', data)
}
// 登陆
export let login = (data) => {
  return axios.post('user/login', data)
}
// 修改密码
export let editPassword = (data) => {
  return axios.post('user/update', data)
}
// 短信验证 无校验
export let codeNum = (data) => {
  return axios.post('user/code_num', data)
}
//开发者认证
export let developerApi = (data) => {
  return axios.post('user/detail', data)
}
//开发者审核
export let examineApi = () => {
  if (getCookie('token')) {
    return axios.post('user/show')
  }else {
    return false
  }
}

// 获取用户信息id
export let getUserId = () => {
  if (getCookie('token')) {
    return axios.post('user/get_user_id')
  } else {
    return false
  }
}
// 获取技能列表
export let SkillListApi = (id) => {
  return axios.get(`/nlu/skills?dev_id=${id}`)
}
// 创建技能
export let createdSkillApi = (data) => {
  return axios.post('/nlu/skills/create', data)
}
// 校验技能名是否重复
export let nameRepeatApi = (data) => {
  return axios.post('/skills/check_skill_name', data)
}
// 校验技能标识是否重复
export let signRepeatApi = (data) => {
  return axios.post('/skills/skill_domain_check', data)
}
// 获取技能分类
export let skillName = () => {
  return axios.post('/skills/skills_name')
}
// 删除技能
export let deleteSkillApi = (id, data) => {
  return axios.delete(`nlu/skills/${id}`, {data}, {headers:{'Content-Type': 'application/json'}})
}
// 编辑技能
export let updateSkillApi = (data) => {
  return axios.put(`/nlu/skills/update`, data)
}
// 配置服务
export let settingSerApi = (data) => {
  return axios.post('/skills/skill_service', data)
}
// 发布上线--保存
export let saveReleaseApi = (data) => {
  return axios.post('/skills/skills_release_save', data)
}
// 发布上线
export let releaseApi = (data) => {
  return axios.post('/skills/skills_release', data)
}
// 获取单个技能详情
export let skillDetailApi = (data) => {
  return axios.post('/skills/detail_skills', data)
}
// 获取意图列表
export let getIntentsApi = (id) => {
  return axios.get(`/nlu/intents?skill_id=${id}`)
}
// 查询字典列表
export let searchDictApi = (id) => {
  return axios.post(`/nlu/dicts?skill_id=${id}`, {})
}
// 查询所有字典列表
export let searchAllDictApi = (id) => {
  return axios.post(`/nlu/dicts/_search?skill_id=${id}`)
}

// 常用表达添加
export let addExpApi = (id, data) => {
  return axios.post(`/nlu/basic_extract?skill_id=${id}`, data)
}
// 创建意图
export let addIntentsApi = (data) => {
  return axios.post(`/nlu/intents/train`, data, {headers:{'Content-Type': 'application/json'}})
}
// 获取系统意图
export let sysListApi = (id) => {
  return axios.get(`/nlu/intents/sys?skill_id=${id}`)
}
// 删除系统意图
export let removeintApi = (id) => {
  return axios.delete(`/nlu/intents/user?intent_id=${id}`)
}
//引用系统意图
export let refSysIntApi = (data) => {
  return axios.post(`/nlu/intents/sys/_ref`, data)
}
//取消引用系统意图
export let calSysIntApi = (data) => {
  return axios.delete(`/nlu/intents/sys/_ref`, {data})
}
// 获取意图详情（编辑）
export let getIntApi = (id) => {
    // /nlu/intents/sys/info?id=${id}
  return axios.get(`/nlu/intents?intent_id=${id}`)
}
// 获取系统意图详情
export let getSysIntApi = (id) => {
    return axios.get(`/nlu/intents/sys/info?id=${id}`)
}
//消息列表
export let messagesListApi = (data) => {
  return axios.post(`/skills/message_center`, data)
}
//新消息数量
export let messagesNewApi = (data) => {
  return axios.post(`/skills/new_message_check`, data)
}
//消息已读
export let messagesCbApi = (data) => {
  return axios.post(`/skills/read_message_callback`, data)
}
//提交push
export let pushApi = (data) => {
  return axios.post(`/skills/push_application`, data)
}
// tts接口音频
export let ttsApi = (data) => {
  return axios.post(`/skills/text_to_audio`, data)
}
// 版本管理列表
export let versionApi = (data) => {
  return axios.post(`/skills/version_manage_list`, data)
}
// 版本管理版本删除操作
export let delCurrentApi = (id,data) => {
  return axios.delete(`/nlu/skills/${id}`, {data}, {headers:{'Content-Type': 'application/json'}})
}
// 版本管理历史版本删除操作
export let delVersionApi = (data) => {
  return axios.delete(`/nlu/version/delete`, {data}, {headers:{'Content-Type': 'application/json'}})
}
// 版本管理撤回操作
export let returnCurrentApi = (data) => {
  return axios.post(`skills/revoke_online_audit`, data)
}

// 版本管理更新操作
export let upDataVersionApi = (data) => {
  return axios.post(`/nlu/version/update`, data)
}
// 版本管理使用人数
export let personNumApi = (data) => {
  return axios.post(`/data/user_num`, data)
}

// 版本管理交互次数
export let interactiveApi = (data) => {
  return axios.post(`/data/interactive`, data)
}

// 版本管理平均交互次数
export let averageApi = (data) => {
  return axios.post(`/data/frequency`, data)
}
// 数据概览 整体概况
export let generalizeApi = (data) => {
  return axios.post(`/data/all`, data)
}
// 获取多轮前置意图列表
export let getPrepositiveApi = (skillId, intentId) => {
  return axios.get(`/nlu/intents/user?skill_id=${skillId}&intent_id=${intentId}`)
}

// 前置意图槽位列表
export let needIntentApi = (id, data) => {
  return axios.post(`/nlu/intents/entities?skill_id=${id}`, data)
}

//即时测试



//在线测试
export let testApi = (data) => {
  return axios.post('/nlu/parse',data, {headers:{'Content-Type': 'application/json'}})
}
export let postTest = (data) => {
  return axios.post('/skills/auto_test',data, {headers:{'Content-Type': 'application/json'}})
}


// 列出所有的系统词典名字
export let postSysDict = (id) => {
  return axios.post(`/nlu/dicts/sys?skill_id=${id}`).then(res => res.data)
}
// 设置需要引用的系统词典
export let postSysDictRef = (id,data) => {
  return axios.post(`/nlu/dicts/sys/_ref?skill_id=${id}`,data,{headers:{'Content-Type': 'application/json'}}).then(res => res.data)
}
// 设置需要引用的系统词典
export let delSysDictRef = (id,params) => {
  return axios.delete(`/nlu/dicts/sys?skill_id=${id}`,{headers:{'Content-Type': 'application/json'},data:params}).then(res => res.data)
}
// 添加自定义词典
export let postCreate = (id,params) => {
  return axios.post(`/nlu/dicts/user/_create?skill_id=${id}`,params,{headers:{'Content-Type': 'application/json'}}).then(res => res.data)
}
//删除自定义词典
export let delCreate = (id,params) => {
  return axios.delete(`/nlu/dicts/user?skill_id=${id}`,{headers:{'Content-Type': 'application/json'},data:params}).then(res => res.data)
}
// 分页展示某一自定义词典的一部分内容
export let postDictPage = (id,num,params) => {
  return axios.post(`/nlu/dicts/user/show?skill_id=${id}&page_size=20&page_num=${num}`,params,{headers:{'Content-Type': 'application/json'}}).then(res => res.data)
}
// 编辑自定义词典
export let postDict = (id,num,params) => {
  return axios.post(`/nlu/dicts/user/edit?skill_id=${id}&page_size=20&page_num=${num}`,params).then(res => res.data)
}
// 已使用的词典列表
export let postUsedDict = (id,num) => {
  return axios.post(`/nlu/dicts?skill_id=${id}`).then(res => res.data)
}
//查询词典
export let postSearch = (id,params) => {
  return axios.post(`/nlu/dicts/_search?skill_id=${id}`,params).then(res => res.data)
}
//导出字典
export let exportDictApi = (data) => {
  return axios.post(`/nlu/dicts/user/export`,data ,{headers:{'Content-Type': 'application/json'}})
}
//导出字典  URL
/*
export  let exportUrl=()=>{
  return config.host./nlu/dicts/user/export?skill_id=${skill_id}&dict_id=${dict_id}
}
*/



/*
// 获取多轮前置意图列表
export let getPrepositiveApi = (skillId, intentId) => {
  return axios.get(`/nlu/intents/user?skill_id=${skillId}&intent_id=${intentId}`)
}
*/

//用户技能授权
export let saveAuthorizationApi = (data) => {
    return axios.post(`/skills/linkAccount`, data)
}
//获取云端设备
export let cloudEndApi = (data) => {
    return axios.post(`/skills/smarthome_device_discovery`, data)
}
//授权信息查询
export let searchAccountInfoApi = (data) => {
    return axios.post(`/skills/accountInfo`, data)
}


//获取欢迎语结束语
export let getWords = (skill_id) => {
    return axios.get(`/nlu/greets?skill_id=${skill_id}`)
}
//新增欢迎语结束语
export let addWords = (skill_id, data) => {
    return axios.post(`/nlu/greets?skill_id=${skill_id}`, data)
}
//删除欢迎语结束语
export let removeWords = (skill_id,id) => {
    return axios.delete(`/nlu/greets?skill_id=${skill_id}&id=${id}`)
}
//词典导入接口
export let writeFile = (data) => {
    return axios.post(`nlu/dicts/upload`, data, {headers:{'Content-Type': 'application/json'}})
}


// WEBPACK FOOTER //
// ./src/api/index.js